import { lazy } from 'react';

const ElcReportRoutes = [
    {
        path: '/apb_reports',
        component: lazy(() => import('../../pages/Reports/ApbReports')),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba_reports',
        },
    },
    {
        path: '/reports/elc_reports',
        component: lazy(() => import('../../pages/Reports/ElcReports')),
        exact: true,
        meta: {
            action: 'read',
            resource: 'elc_reports',
        },
    },
    {
        path: '/reports/elc_reports/transactions',
        component: lazy(() =>
            import('../../pages/Reports/ElcReports/Transactions'),
        ),
        exact: true,
        meta: {
            action: 'read',
            resource: 'elc_reports',
        },
    },
    {
        path: '/reports/elc_reports/cash_transactions',
        component: lazy(() =>
            import('../../pages/Reports/ElcReports/CashTransactions'),
        ),
        exact: true,
        meta: {
            action: 'read',
            resource: 'elc_reports',
        },
    },
    {
        path: '/reports/elc_reports/business_hours',
        component: lazy(() =>
            import('../../pages/Reports/ElcReports/BusinessHours'),
        ),
        exact: true,
        meta: {
            action: 'read',
            resource: 'elc_reports',
        },
    },
    {
        path: '/reports/elc_reports/matters',
        component: lazy(() => import('../../pages/Reports/ElcReports/Matters')),
        exact: true,
        meta: {
            action: 'read',
            resource: 'elc_reports',
        },
    },
    {
        path: '/reports/elc_reports/payouts',
        component: lazy(() => import('../../pages/Reports/ElcReports/Payouts')),
        exact: true,
        meta: {
            action: 'read',
            resource: 'elc_reports',
        },
    },
];

export default ElcReportRoutes;
